import React, { useState } from 'react';
import { OnboardingData, MinutesPerDay } from '../../types/onboarding';

interface Props {
    onNext: (data: Partial<OnboardingData>) => void;
    onBack: () => void;
    initialData: Partial<OnboardingData>;
    isTransitioning?: boolean;
}

const OnboardingCadence: React.FC<Props> = ({ onNext, onBack, initialData, isTransitioning }) => {
    const [selectedMinutes, setSelectedMinutes] = useState<MinutesPerDay | undefined>(undefined);

    const handleSelect = (minutes: MinutesPerDay) => {
        setSelectedMinutes(minutes);
        // Delay to show selected state
        setTimeout(() => {
            // Default to 7 days a week to encourage daily habit
            onNext({ minutesPerDay: minutes, daysPerWeek: 7 });
        }, 350);
    };

    const Option: React.FC<{
        label: string,
        minutesValue: MinutesPerDay,
        currentValue: MinutesPerDay | undefined
    }> = ({ label, minutesValue, currentValue }) => (
        <button
            onClick={() => handleSelect(minutesValue)}
            disabled={isTransitioning}
            className={`w-full px-6 py-3.5 rounded-xl border-2 border-b-[6px] transition-all duration-200 text-base font-bold ${minutesValue === currentValue
                ? 'border-brand-orange bg-[#fed7aa] text-brand-orange shadow-sm translate-y-[2px]'
                : 'border-gray-300 dark:border-gray-600 hover:border-brand-orange/50 hover:bg-gray-50 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-200'
                } active:border-b-2 active:translate-y-[6px] disabled:opacity-50 disabled:cursor-not-allowed`}
        >
            {label}
        </button>
    );

    return (
        <div className="space-y-12 animate-in fade-in slide-in-from-right-4 duration-300">
            {/* Q3 */}
            <div>
                <label className="block text-gray-900 dark:text-white font-bold text-2xl mb-2">Kolik času dáš denně?</label>
                <p className="text-gray-500 dark:text-gray-400 text-sm mb-8">
                    Zvol si realistický cíl, kterého se budeš držet
                </p>
                <div className="flex flex-col gap-3 max-w-md mx-auto">
                    <Option label="15 min" minutesValue={15} currentValue={selectedMinutes} />
                    <Option label="30 min" minutesValue={30} currentValue={selectedMinutes} />
                    <Option label="60 min" minutesValue={60} currentValue={selectedMinutes} />
                    <Option label="90+ min" minutesValue={90} currentValue={selectedMinutes} />
                </div>
            </div>
        </div>
    );
};

export default OnboardingCadence;
